// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__8Px-0","rotation":"Loading_rotation__WS8DE"};